<template>
  <v-container class="ma-0 pa-0 mt-1">
    <h2>Classroom Plan{{ subscriptions.length > 1 ? "s" : "" }}</h2>
    <v-card outlined="" flat="" v-if="loading">
      <v-skeleton-loader
        ref="skeleton"
        :boilerplate="true"
        type="card-heading, list-item-three-line"
      ></v-skeleton-loader>
    </v-card>
    <template v-if="!loading">
      <template v-for="sub in subs" class="mt-0">
        <subscriptionCard :subscriptionid="sub" :key="sub" :hide="hide" />
      </template>
      <template v-if="subs.length === 0">
        <v-card outlined="" flat="">
          <v-card-title>
            <b>Pick a plan to get started</b>
          </v-card-title>
          <div class="pl-4 pr-4">
            <!-- <p class="body-1">
              <span class="mr-2"
                >Pick a plan to unlock user enrollments<br
              /></span>
            </p> -->
            <p>
              <v-btn
                depressed=""
                color="#FF6247"
                dark=""
                rounded=""
                :to="{ name: 'billing-plans' }"
                >Get Started</v-btn
              >
            </p>
          </div>
        </v-card>
      </template>
    </template>
    <template>
      <h2 class="mt-3 mb-3">Support</h2>
      <v-card flat="" outlined="">
        <v-card-title><b>Contacts</b></v-card-title>
        <div class="pl-4 pr-4">
          <p class="body-1">
            <span class="mr-2"
              ><b>Email: </b>
              <a href="mailto:billing@arist.co">billing@arist.co</a></span
            >
          </p>
        </div>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import services from "@/services";
import subscriptionCard from "./plan-card";
export default {
  props: ["hide"],
  components: {
    subscriptionCard
  },
  data: () => ({
    loading: false,
    error: false,
    subscriptions: []
  }),
  computed: {
    subs() {
      return this.subscriptions.map(sub => {
        return sub.id;
      });
    }
  },
  methods: {
    async getSubscriptions() {
      const results = await services.billing.subscriptions.get();
      return results;
    }
  },
  async mounted() {
    try {
      this.loading = true;
      const results = await this.getSubscriptions();
      this.subscriptions = results;
      console.log(results);
      this.loading = false;
    } catch (err) {
      this.error = true;
      this.loading = false;
    }
  }
};
</script>

<style></style>
